<div class="content">
    <div class="content-header">
        <h1>Configuración de presorteo</h1>
    </div>
    <div class="content-body">
        <div class="card">
            <div class="section">
                <h3 style="color:rgb(236, 161, 74)">Sets de Bolillas (principales)</h3>
                <div class="framework holderOrangeM p-d-flex p-jc-evenly">
                    <div class="firstM">
                        <div class="icon" style="color:rgb(236, 161, 74)">
                            <i class="fa-solid fa-toolbox"></i>
                        </div>
                        <div class="title">
                            <p class="crd-title p-mb-5">Mega Pozo y Mega Chance</p>
                        </div>
                        <div class="holderNumbers">
                            <div class="p-d-flex p-jc-evenly p-mb-4">
                                <div>
                                    <h5 class="p-mb-0">6/36</h5>
                                </div>
                                <p class="show-result">#</p>
                            </div>
                        </div>
                    </div>
                    <div class="SecondM">
                        <div class="icon" style="color:rgb(236, 161, 74)">
                            <i class="fa-solid fa-toolbox"></i>
                        </div>
                        <div class="title">
                            <p class="crd-title p-mb-5">Mega Revancha</p>
                        </div>
                        <div class="holderNumbers">
                            <div class="p-d-flex p-jc-evenly p-mb-4">
                                <div>
                                    <h5 class="p-mb-0">6/36</h5>
                                </div>
                                <p class="show-result">#</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section" style="margin-top: 4em;">
                <h3 style="color:rgb(116, 116, 116)">Sets de Bolillas (contingencia)</h3>
                <div class="framework holderGrayM p-d-flex p-jc-evenly">
                    <div class="firstM">
                        <div class="icon" style="color:rgb(116, 116, 116)">
                            <i class="fa-solid fa-compact-disc"></i>
                        </div>
                        <div class="title">
                            <p class="crd-title p-mb-5">Mega Pozo y Mega Chance</p>
                        </div>
                        <div class="holderNumbers">
                            <div class="p-d-flex p-jc-evenly p-mb-4">
                                <div>
                                    <h5 class="p-mb-0">6/36</h5>
                                </div>
                                <p class="show-result">#</p>
                            </div>
                        </div>
                    </div>

                    <div class="SecondM">
                        <div class="icon" style="color:rgb(116, 116, 116)">
                            <i class="fa-solid fa-compact-disc"></i>
                        </div>
                        <div class="title">
                            <p class="crd-title p-mb-5">Mega Revancha</p>
                        </div>
                        <div class="holderNumbers">
                            <div class="p-d-flex p-jc-evenly p-mb-4">
                                <div>
                                    <h5 class="p-mb-0">6/36</h5>
                                </div>
                                <p class="show-result">#</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
